export function isReferrerSameDomain() {
  // Check if there is a referrer
  if (!document.referrer || document.referrer.includes("/logout")) {
    return false; // No referrer available
  }

  try {
    // Parse the referrer URL
    const referrerURL = new URL(document.referrer);

    // Get the current page's URL components
    const currentURL = window.location;

    // Compare the hostname
    const sameHostname = referrerURL.hostname === currentURL.hostname;

    // Optionally, compare the protocol as well
    // const sameProtocol = referrerURL.protocol === currentURL.protocol;

    // Return true if hostname matches (and protocol if checked)
    return sameHostname; // && sameProtocol;
  } catch (e) {
    // If URL parsing fails, assume different domain
    console.error("Invalid referrer URL:", e);
    return false;
  }
}

export function redirectAfterLogin() {
  if (!isReferrerSameDomain() || location.pathname !== "/login") {
    location.reload();
  } else {
    location.href = document.referrer;
  }
}
